import type { SVGProps } from "react";
export function Trash(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m5.50008 2.66667c0-.64434.52233-1.16667 1.16667-1.16667h2.66666c.64434 0 1.16669.52233 1.16669 1.16667v1.5h2.1615c.0031-.00003.0061-.00003.0093 0h.6625c.2761 0 .5.22386.5.5s-.2239.5-.5.5h-.2011l-.545 7.63063c-.0686.9594-.8669 1.7027-1.8287 1.7027h-5.51703c-.96184 0-1.76014-.7433-1.82867-1.7027l-.54505-7.63063h-.2011c-.27614 0-.5-.22386-.5-.5s.22386-.5.5-.5h.66253c.00311-.00003.00621-.00003.0093 0h2.1615zm-1.62968 2.5.53996 7.55943c.03115.436.39401.7739.83121.7739h5.51703c.4372 0 .8001-.3379.8312-.7739l.5399-7.55943zm5.62968-1h-3v-1.5c0-.09205.07462-.16667.16667-.16667h2.66666c.09207 0 .16667.07462.16667.16667zm-2.83333 2.66666c.27613 0 .5.22387.5.5v3.99997c0 .2762-.22387.5-.5.5-.27614 0-.5-.2238-.5-.5v-3.99997c0-.27613.22386-.5.5-.5zm2.66666 0c.27614 0 .5.22387.5.5v3.99997c0 .2762-.22386.5-.5.5-.27613 0-.5-.2238-.5-.5v-3.99997c0-.27613.22387-.5.5-.5z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
